<!--
  Configuraciones por tramas (solo administradores). Mismo concepto que panel-alerts:
  escritorio (>= 1400px) con las secciones fijas a la izquierda y la lista a la derecha;
  compacto (< 1400px) con la lista a todo lo ancho y las secciones en una hoja inferior.
-->
<div class="settings-panel" *ngIf="isAdmin">
  <!-- Fondo de la hoja de secciones: solo se ve en compacto con la hoja abierta -->
  <div
    class="settings-panel__sheet-backdrop"
    [class.is-open]="sectionsSheetOpen"
    (click)="closeSectionsSheet()"
  ></div>

  <!-- Escritorio: columna fija. Compacto: hoja inferior -->
  <div class="settings-panel__sections" [class.is-open]="sectionsSheetOpen">
    <div
      class="settings-panel__sheet-header"
      appSheetSwipe
      sheetSelector=".settings-panel__sections"
      (swipeDown)="closeSectionsSheet()"
    >
      <span class="settings-panel__sheet-handle"></span>
      <span
        class="settings-panel__sheet-close"
        role="button"
        tabindex="0"
        [attr.aria-label]="'general.close' | translate"
        (click)="closeSectionsSheet()"
        (keydown.enter)="closeSectionsSheet()"
        >&times;</span
      >
    </div>

    <h4 class="settings-panel__title">{{ "settings-modal.config-sections" | translate }}</h4>

    <!-- Sensibilidad -->
    <div class="settings-section" [class.is-open]="!sectionSensitivity">
      <button
        type="button"
        class="settings-section__toggle"
        (click)="closeALLSection(); sectionChange.toggle()"
        [attr.aria-expanded]="!sectionSensitivity"
      >
        <span>{{ "settings-modal.sensitivity" | translate }}</span>
        <em class="fa fa-chevron-down settings-section__chevron" aria-hidden="true"></em>
      </button>
      <div #sectionChange="ngbCollapse" id="sectionChange" [(ngbCollapse)]="sectionSensitivity">
        <div class="settings-section__body">
          <button
            type="button"
            class="btn btn-success btn-block"
            (click)="testActions('CHANGE_SETTING_FRAME', '')"
          >
            {{ "settings-modal.get-sensitivity" | translate }}
            <em class="fa fa-refresh ml-1"></em>
          </button>
          <div class="settings-field" *ngFor="let item of configurations[4].options">
            <label class="settings-field__label">{{ item.label }}</label>
            <div class="settings-field__row">
              <select [(ngModel)]="item.data" name="data" class="form-control">
                <option value="">{{ "settings-modal.select-sensitivity" | translate }}</option>
                <option value="5">{{ "settings-modal.sensitivity" | translate }} 5A</option>
                <option value="20">{{ "settings-modal.sensitivity" | translate }} 20A</option>
              </select>
              <button
                type="button"
                class="btn btn-secondary settings-save-btn"
                (click)="testActions(configurations[4].type, item)"
                [disabled]="!item.data"
              >
                <img src="assets/img/icons/save.svg" alt="save" width="26" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Velocidad -->
    <div class="settings-section" [class.is-open]="!sectionSpeed">
      <button
        type="button"
        class="settings-section__toggle"
        (click)="closeALLSection(); sectionSpeedCollapse.toggle()"
        [attr.aria-expanded]="!sectionSpeed"
      >
        <span>{{ "tables.speed" | translate }}</span>
        <em class="fa fa-chevron-down settings-section__chevron" aria-hidden="true"></em>
      </button>
      <div #sectionSpeedCollapse="ngbCollapse" id="sectionSpeed" [(ngbCollapse)]="sectionSpeed">
        <div class="settings-section__body">
          <app-speed
            [type]="'masive'"
            [lisFeeders]="selectedFeeders"
            (submitPetition)="changeDataSpeed($event)"
            [header]="false"
          >
          </app-speed>
        </div>
      </div>
    </div>

    <!-- Cambio de puerto -->
    <div class="settings-section" [class.is-open]="!sectionAnnalog">
      <button
        type="button"
        class="settings-section__toggle"
        (click)="closeALLSection(); changePort.toggle()"
        [attr.aria-expanded]="!sectionAnnalog"
      >
        <span>{{ "offsidebar.configuration.port-change" | translate }}</span>
        <em class="fa fa-chevron-down settings-section__chevron" aria-hidden="true"></em>
      </button>
      <div #changePort="ngbCollapse" id="changePort" [(ngbCollapse)]="sectionAnnalog">
        <div class="settings-section__body">
          <button
            type="button"
            class="btn btn-success btn-block"
            (click)="testActions('ANALOG_READING', 'button')"
          >
            {{ configurations[0].getButtonText }}
            <em class="fa fa-refresh ml-1"></em>
          </button>
          <div class="settings-field">
            <label class="settings-field__label">{{ configurations[0].label }}</label>
            <div class="settings-field__row">
              <select
                class="form-control"
                name="ANALOG_READING"
                [(ngModel)]="configurations[0].value"
              >
                <option value="">{{ "offsidebar.configuration.select-port" | translate }}</option>
                <option *ngFor="let port of configurations[0].ports" [value]="port">
                  A{{ port }}
                </option>
              </select>
              <button
                type="button"
                class="btn btn-secondary settings-save-btn"
                (click)="testActions(configurations[0].type, configurations[0].value)"
                [disabled]="configurations[0].value === ''"
              >
                <img src="assets/img/icons/save.svg" alt="save" width="26" />
              </button>
            </div>
          </div>

          <!-- Alerta de apertura del dosificador: switch para un solo alimentador -->
          <div
            class="settings-field settings-field__switch"
            *ngIf="
              (typeCurrent === 'individual' || typeCurrent === 'masive_feeders') &&
              TemporalFeeder.length === 1
            "
          >
            <span class="settings-field__label mb-0">{{ configurations[0].titleButtons }}</span>
            <label class="switch m-0">
              <input
                type="checkbox"
                [(ngModel)]="configurations[0].BooleanAlertReading"
                [value]="!configurations[0].BooleanAlertReading ? 1 : 0"
                [checked]="configurations[0].BooleanAlertReading"
                (change)="changeAnalogReadingAlert(!configurations[0].BooleanAlertReading ? 1 : 0)"
              />
              <span class="slider round"></span>
            </label>
          </div>

          <!-- Alerta de apertura del dosificador: botones ON/OFF para varios alimentadores -->
          <div
            class="settings-field"
            *ngIf="
              TemporalFeeder.length > 1 &&
              (typeCurrent === 'masive_feeders' || typeCurrent === 'masive_ponds')
            "
          >
            <span class="settings-field__label">{{ configurations[0].titleButtons }}</span>
            <div class="settings-field__buttons">
              <button
                type="button"
                class="btn"
                *ngFor="let button of configurations[0].buttons"
                [ngClass]="button.class"
                (click)="testActions(button.type, button.value)"
              >
                <b>{{ button.value }}</b>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Corriente aspersor y dosificador -->
    <div class="settings-section" [class.is-open]="!sectionCurrent">
      <button
        type="button"
        class="settings-section__toggle"
        (click)="closeALLSection(); secCurrent.toggle()"
        [attr.aria-expanded]="!sectionCurrent"
      >
        <span>{{ "settings-modal.current-and-sprinkler" | translate }}</span>
        <em class="fa fa-chevron-down settings-section__chevron" aria-hidden="true"></em>
      </button>
      <div #secCurrent="ngbCollapse" id="secCurrent" [(ngbCollapse)]="sectionCurrent">
        <div class="settings-section__body">
          <button
            type="button"
            class="btn btn-success btn-block"
            (click)="testActions(configurations[1].type, 'button')"
          >
            {{ configurations[1].getButtonText }}
            <em class="fa fa-refresh ml-1"></em>
          </button>

          <div class="settings-field">
            <label class="settings-field__label">{{ configurations[1].labelSprinkler }}</label>
            <div class="settings-field__row">
              <input
                type="number"
                [(ngModel)]="configurations[1].valueSprinkler"
                class="form-control"
              />
              <button
                type="button"
                class="btn btn-secondary settings-save-btn"
                (click)="
                  testActions(configurations[1].typeSprinkler, configurations[1].valueSprinkler)
                "
              >
                <img src="assets/img/icons/save.svg" alt="save" width="26" />
              </button>
            </div>
            <small
              class="text-danger"
              *ngIf="
                configurations[1].valueSprinkler < 0.09 || configurations[1].valueSprinkler > 0.2
              "
            >
              {{ "settings-modal.sprinkler-range-error" | translate }}
            </small>
          </div>

          <div class="settings-field">
            <label class="settings-field__label">{{ configurations[1].labelDispenser }}</label>
            <div class="settings-field__row">
              <input
                type="number"
                [(ngModel)]="configurations[1].valueDispenser"
                class="form-control"
              />
              <button
                type="button"
                class="btn btn-secondary settings-save-btn"
                (click)="
                  testActions(configurations[1].typeDispenser, configurations[1].valueDispenser)
                "
              >
                <img src="assets/img/icons/save.svg" alt="save" width="26" />
              </button>
            </div>
            <small
              class="text-danger"
              *ngIf="configurations[1].valueDispenser < 0.9 || configurations[1].valueDispenser > 2"
            >
              {{ "settings-modal.dispenser-range-error" | translate }}
            </small>
          </div>
        </div>
      </div>
    </div>

    <!-- Tasa de alimentacion: la seccion esta deshabilitada (sin boton que la abra) -->
    <div #secFeedRate="ngbCollapse" id="secFeedRate" [(ngbCollapse)]="sectionFeedRate">
      <div class="settings-section__body">
        <div class="settings-field">
          <label class="settings-field__label">{{ configurations[2].label }}</label>
          <div class="settings-field__row">
            <input type="number" [(ngModel)]="configurations[2].value" class="form-control" />
            <button
              type="button"
              class="btn btn-secondary settings-save-btn"
              (click)="testActions(configurations[2].type, configurations[2].value)"
              [disabled]="configurations[2].value < 0 || configurations[2].value > 255"
            >
              <img src="assets/img/icons/save.svg" alt="save" width="26" />
            </button>
          </div>
          <small
            class="text-danger"
            *ngIf="configurations[2].value < 0 || configurations[2].value > 255"
          >
            {{ "settings-modal.feed-rate-range-error" | translate }}
          </small>
        </div>
      </div>
    </div>

    <!-- Alerta de dosificador -->
    <div class="settings-section" [class.is-open]="!sectionAlertDispenser">
      <button
        type="button"
        class="settings-section__toggle"
        (click)="closeALLSection(); secAlertDispenser.toggle()"
        [attr.aria-expanded]="!sectionAlertDispenser"
      >
        <span>{{ "settings-modal.dispenser-alert" | translate }}</span>
        <em class="fa fa-chevron-down settings-section__chevron" aria-hidden="true"></em>
      </button>
      <div
        #secAlertDispenser="ngbCollapse"
        id="secAlertDispenser"
        [(ngbCollapse)]="sectionAlertDispenser"
      >
        <div class="settings-section__body">
          <button
            type="button"
            class="btn btn-success btn-block"
            (click)="testActions('REQUEST_DISPENSER_ALERT', '')"
          >
            {{ "settings-modal.get-dispenser-alert" | translate }}
          </button>
          <div class="settings-field settings-field__switch">
            <span class="settings-field__label mb-0">
              {{ "settings-modal.enable-disable-dispenser-alert" | translate }}
            </span>
            <label class="switch m-0">
              <input
                type="checkbox"
                [(ngModel)]="alert_dosificator"
                [value]="!alert_dosificator ? 1 : 0"
                [checked]="alert_dosificator"
                (change)="testActions('CHANGE_ALERT_DISPENSER', '')"
              />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="settings-panel__right">
    <!-- Compacto: boton que abre la hoja de secciones -->
    <button type="button" class="settings-panel__sections-trigger" (click)="openSectionsSheet()">
      <em class="fa fa-sliders" aria-hidden="true"></em>
      <span class="settings-panel__trigger-label">{{
        "settings-modal.config-sections" | translate
      }}</span>
      <em class="fa fa-chevron-up settings-panel__trigger-chevron" aria-hidden="true"></em>
    </button>

    <!-- Filtros -->
    <div class="settings-panel__filters">
      <select
        class="form-control"
        name="filterStatusFeeders"
        id="filterStatusFeeders"
        [(ngModel)]="filterStatusFeeders"
        (change)="filterItems()"
      >
        <option value="">{{ "general.all" | translate }}</option>
        <option value="error">{{ "filter.error" | translate }}</option>
        <option value="done">{{ "filter.done" | translate }}</option>
        <option value="loading">{{ "filter.loading" | translate }}</option>
      </select>
      <select
        *ngIf="type === 'ponds'"
        class="form-control"
        name="filterPondSeleected"
        id="filterPondSeleected"
        [(ngModel)]="filterPondSeleected"
        (change)="filterItems()"
      >
        <option value="">{{ "general.all" | translate }}</option>
        <option *ngFor="let pond of inputPondSelect" [value]="pond.id">
          {{ pond.name }}
        </option>
      </select>
      <input
        class="form-control"
        type="text"
        [(ngModel)]="nameInput"
        name="nameInput"
        (input)="filterItems()"
        placeholder="{{ 'filter.feeder-name' | translate }}"
      />
    </div>

    <!-- Pestanas de estanques: se desplazan en horizontal si no caben -->
    <ul
      class="nav nav-tabs settings-panel__tabs"
      *ngIf="TemporalFeeder.length > 0 && type === 'ponds'"
    >
      <ng-container *ngFor="let item of TemporalFeeder">
        <li
          class="nav-item c-pointer"
          *ngIf="item.linked_feeders.length > 0"
          (click)="selectPond(item)"
        >
          <a class="nav-link" [ngClass]="{ active: pondSelected.id === item.id }">{{
            item.name
          }}</a>
        </li>
      </ng-container>
    </ul>

    <!-- Respuestas por alimentador -->
    <div
      class="frame-rectangle"
      id="parentDiv"
      scrollSpy
      [spiedTags]="['SECTION']"
      (sectionChange)="onSectionChange($event)"
    >
      <ng-container *ngIf="TemporalFeeder.length > 0 && type === 'ponds'">
        <ng-container *ngFor="let pond of TemporalFeeder">
          <section [id]="'Section' + pond.id" *ngIf="pond.linked_feeders.length > 0">
            <h3 class="settings-panel__pond-name">{{ pond.name }}</h3>
            <ul class="settings-panel__feeders">
              <ng-container *ngFor="let feeder of pond.linked_feeders">
                <app-alert-settings
                  [pond]="pond"
                  [feeder]="feeder"
                  [test]="test"
                  [pondSelected]="pondSelected"
                  [showView]="showView"
                ></app-alert-settings>
              </ng-container>
            </ul>
          </section>
        </ng-container>
      </ng-container>

      <ul class="settings-panel__feeders" *ngIf="type === 'feeder'">
        <ng-container *ngFor="let feeder of TemporalFeeder">
          <app-alert-settings
            [pond]="pond"
            [feeder]="feeder"
            [test]="test"
            [pondSelected]="pondSelected"
            [selectedFeeders]="TemporalFeeder"
            [showView]="showView"
          ></app-alert-settings>
        </ng-container>
      </ul>
    </div>
  </div>
</div>
